import React, { useEffect, useState } from 'react';
import Home_Hero_One from '../images/videos/Tattva Realty Hyderabad Promo.mp4'
import Home_Hero_Two from '../images/videos/Tattva Realty Dubai Promo.mp4'
import Home_Hero_One_Tablet from '../images/videos/Tattva Realty Hyderabad Promo (Tab Version).mp4'
import Home_Hero_Two_Tablet from '../images/videos/Tattva Realty Dubai Promo (Tab Version).mp4'
import Home_Hero_One_Mobile from '../images/videos/Tattva Realty Hyderabad Promo (Mobile Version).mp4'
import Home_Hero_Two_Mobile from '../images/videos/Tattva Realty Dubai Promo (Mobile Version).mp4'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css'
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import Quote_Icon from '../images/quote.png'
import Testi_Line from '../images/testi-line.png'
import Testi_One from '../images/testi-one.jpg'
import Testi_Two from '../images/testi-two.jpg'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Faq from "react-faq-component";
import DiscussFrom from '../components/DiscussForm'
import projects from '../data/ProjectsData';  // your data import
// Home projects
import FlatProject from '../images/projects/Flats/ASBL Broadway/main.jpg'
import VillaProject from '../images/projects/Villas/Auro Realty - Sansa County Sector 1/main.png'
import PlotProject from '../images/projects/Plots/Fortune Retreat/main.png'
import CommercialProject from '../images/projects/commercials/Poulomi Infinity/main.jpg'


function Home() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);



  const data = {
    rows: [
      {
        title: "What services does Zamindaar Infra offer?",
        content: `Zamindaar Infra provides a comprehensive range of services, including real estate advisory, PropTech solutions, market research, and analytics to help clients make informed property decisions.`,
        isActive: true, // Set first item as active
      },
      {
        title: "How does Zamindaar Infra ensure transparency in real estate transactions?",
        content: `Transparency is achieved through data-driven insights, detailed market analysis, and clear communication, ensuring clients have complete clarity in every transaction.`,
        isActive: false,
      },
      {
        title: "What is PropTech, and how does Zamindaar Infra use it?",
        content: `PropTech refers to technology-driven solutions in real estate. Zamindaar Infra leverages innovative tools to provide advanced property analytics, virtual property tours, and efficient transaction management.`,
        isActive: false,
      },
      {
        title: "Can Zamindaar Infra help with both residential and commercial properties?",
        content: `Yes, Zamindaar Infra specializes in both residential and commercial real estate, offering tailored solutions to meet diverse client needs.`,
        isActive: false,
      },
      {
        title: "Why should I choose Zamindaar Infra over other firms?",
        content: `Zamindaar Infra combines industry expertise, cutting-edge technology, and a customer-centric approach, making it Hyderabad’s trusted name in real estate advisory and market research.`,
        isActive: false,
      },
    ],
  };

  const styles = {
    bgColor: '#ff8787te',
    titleTextColor: "#ff8787",
    rowTitleColor: "#ff8787ue",
    rowContentColor: 'grey',
    arrowColor: "#ff8787",
  };

  const config = {
    animate: true,
    // arrowIcon: "V",
    tabFocus: true
  };


  return (
    <div className='home-main'>
      {/* <a href="https://wa.me/8897035800"
        id="whatsapp-icon"
        target="_blank"
        title="Chat with us on WhatsApp">
        <img src={whatsAppImg} alt="WhatsApp Icon" id="whatsapp-img" />
      </a> */}
      {/* Home Hero Video */}
      {/* <Carousel controls={false} indicators={false}>
        <Carousel.Item>
          <video src={Home_Hero_One} autoPlay muted loop className="d-block w-100" />
        </Carousel.Item>
      </Carousel> */}
      {/* <Carousel controls={false} indicators={false}>
        <Carousel.Item>
          <video src={Home_Hero_Two} autoPlay muted loop className="d-block w-100" />
        </Carousel.Item>
      </Carousel> */}
      {/* Home Hero Video */}

      {/* Dubai Video Section */}
      <video src={Home_Hero_One} autoPlay loop muted className='video-full d-lg-block d-none'></video>
      <video src={Home_Hero_One_Tablet} autoPlay loop muted className='video-full d-md-block d-lg-none d-none '></video>
      <video src={Home_Hero_One_Mobile} autoPlay loop muted className='video-full d-block d-md-none '></video>
      {/* Dubai Video Section */}
      {/* Home About */}
      <div className='home-about container-fluid py-4'>
        <div className='home-about-inner container py-4'>
          <div className='row justify-content-center '>
            {/* Content on the Right Side */}
            <div className='col-lg-8 col-md-10 my-3 d-flex align-items-center justify-content-center '>
              <div className='home-about-content'>
                <h1 className='syne-title'>ABOU<span className='text-rose'>T</span> US<span className='text-rose'>.</span></h1>
                <h3 className='fw-bold mb-4 syne-title'><span className='text-rose'>Zamindaar Infra:</span> Hyderabad's Leading Real Estate PropTech, Advisory, Market Research & Analytics Firm.</h3>
                <p className='text-secondary'>It is a one-stop solution for all your real estate needs in Hyderabad. Founded in
                  2017, It has grown to become the largest and most trusted real estate
                  consultancy, market research, analytics and construction firm in the city.
                </p>
                <p className='text-secondary'>It offers a wide range of services, the company excels in various facets of the
                  real estate lifecycle, from initial land acquisition to post-sales activities.
                </p>
                <p className='text-secondary'>At the heart of Zamindaar Infra's operations lies its proficiency in Land
                  acquisition Conducting Market Analysis, Feasibility Studies, Project
                  Planning, Development Advisory, Marketing and Sales Strategy,
                  Investment and Valuation Advisory, Asset Management, Legal and
                  Regulatory Compliance - Providing data-driven insights and
                  recommendations based on the latest trends and technologies in the real estate
                  industry.
                </p>
                <p className='text-secondary'>It has a team of highly qualified and experienced professionals who have indepth knowledge and expertise in the property sector. We uses the best tools
                  and techniques to deliver high-quality and reliable services to its clients.
                </p>
                <p className='text-secondary'>Our vision is to be the ultimate destination for real estate solutions in
                  Hyderabad and beyond. Our mission is to create value for its clients by
                  providing them with innovative and customized solutions that meet their needs
                  and expectations.

                </p>
                <p className='text-secondary'>In essence, Zamindaar Infra's comprehensive suite of services and unwavering
                  commitment to excellence position it as a leader in the real estate prop-tech
                  landscape, shaping the future of urban living one development at a time.

                </p>
                <div className='home-about-btn text-start'>
                  <Link to="/about" className="text-rose"><FaLongArrowAltRight /> Read More</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Home About */}
      {/* Dubai Video Section */}
      <video src={Home_Hero_Two} autoPlay loop muted className='video-full d-lg-block d-none'></video>
      <video src={Home_Hero_Two_Tablet} autoPlay loop muted className='video-full d-md-block d-lg-none d-none '></video>
      <video src={Home_Hero_Two_Mobile} autoPlay loop muted className='video-full d-block d-md-none '></video>
      {/* Dubai Video Section */}


      {/* Home Locations */}
      <div className='home-location container-fluid py-4 bg-light'>
        <div className='home-location-inner container py-4'>
          <h1 className='syne-title text-center text-uppercase'>Our Loca<span className='text-rose'>t</span>ions<span className='text-rose'>.</span></h1>
          <p className='mb-4 text-secondary text-center'>At Tattva Realty & Infra, we choose prime locations across Hyderabad that offer the perfect mix of accessibility, luxury, and growth potential. From city centers to peaceful suburbs, our properties ensure unmatched value, convenience, and lifestyle.</p>
          <div className='home-location-imgs container-fluid'>
            {/* //// */}
            <div className='row'>
              <div className='col-lg-4 col-md-6 my-2'>
                <Link to='/hyderabad'>
                  <div className='loc-hyd rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">H</span>YDERABAD</h4>
                    </div>
                  </div>
                </Link>
              </div>
              <div className='col-lg-4 col-md-6 my-2'>
                <Link to='/dubai'>
                  <div className='loc-dubai rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">D</span>UBAI</h4>
                    </div>
                  </div>
                </Link>
              </div>
              <div className='col-lg-4 col-md-6 my-2'>
                <Link to='/banglore'>
                  <div className='loc-bnglr rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">B</span>ANGLORE</h4>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
            {/* Additional project items can follow the same structure */}
            <div className='home-about-btn text-center mt-4'>
              <Link to="/locations" className="text-rose"><FaLongArrowAltRight /> View All</Link>
            </div>
            {/* //// */}
          </div>



        </div>
      </div>
      {/* Home Locations */}
      {/* Home Projects */}
      <div className='container home-projects py-4'>
        <h1 className='syne-title text-center mb-3 text-uppercase'>Our Projec<span className='text-rose'>t</span>s<span className='text-rose'>.</span></h1>
        <p className='mb-4 text-secondary text-center'>Our Project Partnership offers property owners a unique chance to collaborate with Zamindaar Infra in lucrative real estate developments.</p>
        <div className='row'>
          {projects.slice(0, 6).map(({ id, title, location, image, link }) => (
            <div key={id} className='col-lg-4 col-md-6 my-3'>
              <Link to={`/projects/${id}`} className='text-decoration-none text-dark'>
                <div className='home-land-card h-100 shadow-sm'>
                  <img src={image} alt={title} className='img-fluid home-land-card-img' />
                  <div className='home-land-card-content p-3 text-center bg-white'>
                    <h4 className='fw-bold'>{title}</h4>
                    <p className='mb-1'>{location}</p>
                    <div className="home-about-btn text-center">
                      <span className="text-rose">
                        <FaLongArrowAltRight /> Know More
                      </span>
                    </div>
                  </div>
                </div>
              </Link>

            </div>
          ))}
          {/* Additional project items can follow the same structure */}
          <div className='home-about-btn text-center mt-4'>
            <Link to="/projects" className="text-rose"><FaLongArrowAltRight /> View All</Link>
          </div>
        </div>
      </div>

      {/* Home Projects */}
      <div className='home-project container-fluid py-4 bg-light d-md-block d-none'>
        <div className='container py-4'>
          <div className='row'>
            <div className='project-list mt-4 pb-5'>

              {/* Flats */}
              <div className="project-item py-3 position-relative my-2">
                <Link to="/projects/flats">
                  <div className="row align-items-center">
                    <div className="col-4 text-start">
                      <h6 className="mb-0">Flats</h6>
                    </div>
                    <div className="col-1">
                      <span>2025</span>
                    </div>
                    <div className="col-6">
                      <h5 className="text-center project-name">Flats</h5>
                      <div className="project-hover-content position-absolute">
                        <img
                          src={FlatProject}
                          alt="La Paloma Heights Project"
                          className="hover-image"
                        />
                        <div className="hover-info text-center">
                          <p className="mb-0 fs-7">Flats</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 project-arrow">
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Villas */}
              <div className="project-item py-3 position-relative my-2">
                <Link to="/projects/villas">
                  <div className="row align-items-center">
                    <div className="col-4 text-start">
                      <h6 className="mb-0">Villas</h6>
                    </div>
                    <div className="col-1">
                      <span>2025</span>
                    </div>
                    <div className="col-6">
                      <h5 className="text-center project-name">Villas</h5>
                      <div className="project-hover-content position-absolute">
                        <img
                          src={VillaProject}
                          alt="EIPL La Paloma Project"
                          className="hover-image"
                        />
                        <div className="hover-info text-center">
                          <p className="mb-0 fs-7">Villas</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 project-arrow">
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Plots */}
              <div className="project-item py-3 position-relative my-2">
                <Link to="/projects/plots">
                  <div className="row align-items-center">
                    <div className="col-4 text-start">
                      <h6 className="mb-0">Plots</h6>
                    </div>
                    <div className="col-1">
                      <span>2025</span>
                    </div>
                    <div className="col-6">
                      <h5 className="text-center project-name">Plots</h5>
                      <div className="project-hover-content position-absolute">
                        <img
                          src={PlotProject}
                          alt="Tattva Green County Project"
                          className="hover-image"
                        />
                        <div className="hover-info text-center">
                          <p className="mb-0 fs-7">Plots</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 project-arrow">
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Commercial */}
              <div className="project-item py-3 position-relative my-2">
                <Link to="/projects/commercials">
                  <div className="row align-items-center">
                    <div className="col-4 text-start">
                      <h6 className="mb-0">Commercials</h6>
                    </div>
                    <div className="col-1">
                      <span>2025</span>
                    </div>
                    <div className="col-6">
                      <h5 className="text-center project-name">Commercials</h5>
                      <div className="project-hover-content position-absolute">
                        <img
                          src={CommercialProject}
                          alt="Poulomi Infinity Project"
                          className="hover-image"
                        />
                        <div className="hover-info text-center">
                          <p className="mb-0 fs-7">Commercials</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 project-arrow">
                      <i className="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </Link>
              </div>

              {/* View All Link */}
              {/* <div className="home-about-btn text-center mt-4">
                <Link to="/projects" className="text-rose">
                  <FaLongArrowAltRight /> View All
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* Home Projects */}

      {/* Home Testimonials */}
      <div className='home-founders container-fluid py-4'>
        <div className='home-founders container py-4'>
          <div className='row mb-4 container'>
            <div className='col-lg-8 text-start'>
              <h1 className='syne-title'>WHA<span className='text-rose'>T</span><br /> OUR CLIEN<span className='text-rose'>T</span>S SAY<span className='text-rose'>!</span></h1>
            </div>
          </div>
          <Slider
            dots={false}
            infinite={true}
            speed={500}
            slidesToShow={2}
            slidesToScroll={1}
            arrows={true}
            autoplay={true} // Enable auto sliding
            autoplaySpeed={3000} // Set the duration for each slide in milliseconds
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                },
              },
            ]}
          >
            {/* Testi one */}
            <div className='home-testi row d-flex justify-content-center'>
              <div className='home-testi-inner col-md-10'>
                <div className='testi-one-inner-top d-flex align-items-end'>
                  <img src={Quote_Icon} className="w-4 me-2" />
                  <p className='fw-bold mb-0'>Seamless and Rewarding Property Investment </p>
                </div>
                <p className='text-secondary text-start my-2'>" Zamindaar Infra stands out as a real estate partner that truly understands the market dynamics. Their data-driven approach and professional advisory services made my property investment seamless and highly rewarding. They’re not just consultants; they’re visionaries committed to helping clients make informed decisions. I highly recommend them for anyone looking for reliable and insightful real estate services. "</p>
                <img src={Testi_Line} className='img-fluid mt-3' />
                <div className='row'>
                  <div className='col-2'></div>
                  <div className='col-10 d-flex align-items-center testi-one-inner-bottom'>
                    <img src={Testi_One} className='w-15 rounded-circle' />
                    <div className='text-start ms-3'>
                      <p className='fw-bold mb-1'> Ravi Varma, Hyderabad</p>
                      <div className='test-rating'>
                        <i class="fas fa-star text-rose"></i>
                        <i class="fas fa-star text-rose"></i>
                        <i class="fas fa-star text-rose"></i>
                        <i class="fas fa-star text-rose"></i>
                        <i class="fas fa-star text-rose"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Testi one */}
            <div className='home-testi row d-flex justify-content-center'>
              <div className='home-testi-inner col-md-10'>
                <div className='testi-one-inner-top d-flex align-items-end'>
                  <img src={Quote_Icon} className="w-4 me-2" />
                  <p className='fw-bold mb-0'>Unparalleled Clarity and Trust in Real Estate Advisory</p>
                </div>
                <p className='text-secondary text-start my-2'>" In an industry often marred by ambiguity, Zamindaar Infra brings unparalleled clarity and trust. Their PropTech solutions and deep market research helped me identify the perfect investment opportunity. Their team is proactive, transparent, and highly knowledgeable. If you’re looking for real estate expertise in Hyderabad, Zamindaar Infra is the name to trust. "</p>
                <img src={Testi_Line} className='img-fluid mt-3' />
                <div className='row'>
                  <div className='col-2'></div>
                  <div className='col-10 d-flex align-items-center testi-one-inner-bottom'>
                    <img src={Testi_Two} className='w-15 rounded-circle' />
                    <div className='text-start ms-3'>
                      <p className='fw-bold mb-1'>Sushmita Reddy, Secunderabad</p>
                      <div className='test-rating'>
                        <i class="fas fa-star text-rose"></i>
                        <i class="fas fa-star text-rose"></i>
                        <i class="fas fa-star text-rose"></i>
                        <i class="fas fa-star text-rose"></i>
                        <i class="fas fa-star text-rose"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
      {/* Home Testimonials */}
      {/* Home FAQ'S */}
      <div className='container-fluid faq py-4'>
        <div className='container py-4'>
          <h1 className='syne-title text-center mb-4'>FAQ'S<span className='text-rose'>.</span></h1>
          <div className='row d-flex justify-content-center'>
            <div className='col-lg-9'>
              <Faq
                data={data}
                styles={styles}
                config={config}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Home FAQ'S */}
      {/* Home Discuss*/}
      {/* <div className='container-fluid py-5 home-discuss'>
        <div className='container py-5 home-discuss-inner bg-light p-4 rounded-15 shadow-sm'>
          <h1 className='syne-title mb-4 text-start'>
            LET'S DISCUSS<br />YOUR IDEA<span className='text-rose'>.</span>
          </h1>
          <div className='discuss-inner'>
            <div className='row align-items-center'>
              <div className='col-lg-6'>
                <div className='discuss-left text-start'>
                  <p className='text-secondary'>
                    We’re excited to hear your vision! Whether you have a concept or need help brainstorming, our team is ready to collaborate. Let’s connect and turn your idea into reality—schedule a meeting with us today!
                  </p>
                  <div className='discuss-mail d-flex align-items-center my-3'>
                    <i className='fas fa-envelope me-2'></i>
                    <p className='mb-0 text-secondary'>rakesh.tattvahilife@gmail.com</p>
                  </div>
                  <div className='discuss-mail d-flex align-items-center my-3'>
                    <i className='fas fa-mobile-alt me-2'></i>
                    <p className='mb-0 text-secondary'>+91 88970 35800</p>
                  </div>
                  <div className='discuss-mail d-flex align-items-center my-3'>
                    <i className='fas fa-map-marker-alt me-2'></i>
                    <p className='mb-0 text-secondary'>10, Prashanthi Hills, Khajaguda, Gachibowli, Hyderabad</p>
                  </div>
                  <div className='discuss-icons d-flex'>
                    <a href='https://www.linkedin.com/in/tattva-hi-life-735094319/' target='blank' className='text-decoration-none'><i className='fab fa-linkedin-in text-white'></i></a>
                    <a href='https://x.com/TattvaHiLife' className='text-decoration-none'><i className='fab fa-twitter text-white'></i></a>
                    <a href='https://www.facebook.com/profile.php?id=100086552704523' className='text-decoration-none'><i className='fab fa-facebook-f text-white'></i></a>
                    <a href='https://www.instagram.com/tattvahilife_international/' className='text-decoration-none'><i className='fab fa-instagram text-white'></i></a>
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <form action="https://api.web3forms.com/submit" method="POST">
                  <input type="hidden" name="access_key" value="d567d7ce-8cc7-4fdd-a9ae-66c9c3461e68" />
                  <input
                    type='text'
                    placeholder='Name'
                    name="name"
                    className='form-control my-2'
                    required

                  />
                  <input
                    type='text'
                    placeholder='Mobile'
                    name="mobile"
                    className='form-control my-2'
                    required
                  />
                  <input
                    type='email'
                    placeholder='Email'
                    name="email"
                    className='form-control my-2'
                    required
                  />
                  <textarea
                    placeholder='Message'
                    name="message"
                    rows='4'
                    className='form-control my-2'
                    required
                  />
                  <div className='text-start mt-3 d-flex align-items-center'>
                    <span className='fs-2 text-rose'>→</span>
                    <input type='submit' value='Send' className='border-0 text-rose discuss-btn' />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div> */}\
      <DiscussFrom />
      {/* Home Discuss*/}
      {/* Brand Slider */}

      {/* Brand Slider */}


    </div>
  )
}

export default Home